export const normalizeEndpoint = (endpoint?: string) => {
  if (!endpoint) return '';

  const [rawPath, rawQuery = ''] = endpoint.split('?');

  // Clean path: remove leading and trailing slashes
  let cleanedPath = rawPath.replace(/^\/+|\/+$/g, '');

  // Clean query: remove leading and trailing slashes
  let cleanedQuery = rawQuery.replace(/^\/+|\/+$/g, '');

  let isFilter = false;

  // Check if it should be a filter endpoint
  if (cleanedPath.endsWith('/filter')) {
    isFilter = true;
    cleanedPath = cleanedPath.slice(0, -7); // remove '/filter'
  } else if (cleanedPath === 'filter') {
    isFilter = true;
    cleanedPath = '';
  }

  if (cleanedQuery.endsWith('/filter')) {
    isFilter = true;
    cleanedQuery = cleanedQuery.slice(0, -7);
  } else if (cleanedQuery.endsWith('filter')) {
    if (cleanedQuery.endsWith('/filter')) {
      isFilter = true;
      cleanedQuery = cleanedQuery.slice(0, -7);
    } else if (cleanedQuery === 'filter') {
      isFilter = true;
      cleanedQuery = '';
    } else if (cleanedQuery.includes('/filter')) {
      isFilter = true;
      cleanedQuery = cleanedQuery.replace(/\/filter/g, '');
    }
  }

  // Ensure cleanedPath ends with a slash if not empty
  let resultPath = cleanedPath ? `${cleanedPath}/` : '';
  if (isFilter) {
    resultPath = `${resultPath}filter/`;
  }

  // Ensure query params are cleaned up
  cleanedQuery = cleanedQuery.replace(/^\/+|\/+$/g, '');

  return cleanedQuery ? `${resultPath}?${cleanedQuery}` : resultPath;
};
